import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import BaseDb from "./baseDb";
import AnaliseInteligenteMensal from "../models/analiseInteligenteMensal";

export default class AnaliseInteligenteMensalDb extends BaseDb<
  AnaliseInteligenteMensal,
  { usuarioId: string; analiseId: string }
> {
  _path: string = "usuarios/usuarioId/analisesInteligentesMensais/analiseId";
  getConverter(): FirestoreDataConverter<AnaliseInteligenteMensal> {
    return {
      fromFirestore: (snapshot) =>
        new AnaliseInteligenteMensal({
          ref: snapshot.ref.withConverter(this.getConverter()),
          introducao: snapshot.get("introducao"),
          resultados: snapshot.get("resultados"),
          carteira: snapshot.get("carteira"),
          proventos: snapshot.get("proventos"),
          conclusao: snapshot.get("conclusao"),
        }),
      toFirestore: (relatorio: AnaliseInteligenteMensal) => ({
        ...omit(relatorio, ["ref"]),
      }),
    };
  }
}
